// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tLQ35","colBig":"styles_colBig__IurmG","colSmall":"styles_colSmall__3K5pv","shopifyNameWrapper":"styles_shopifyNameWrapper__1sY7h"};